import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Grid from '@mui/joy/Grid';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Switch from '@mui/joy/Switch';
import Button from '@mui/joy/Button';
import IconButton from '@mui/joy/IconButton';
import Box from '@mui/joy/Box';
// import Tooltip from '@mui/joy/Tooltip';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemButton from '@mui/joy/ListItemButton';


import useIdentity from "hooks/useIdentity";
import useUserIdentity from 'hooks/useUserIdentity';
import useMutual from 'hooks/useMutual';
import useRoles from 'hooks/useRoles';
import useDedicatedAssignment from 'hooks/useDedicatedAssignment';
import useWorkKey from 'hooks/useWorkKey';

import { Success, Error } from "./FancyToast";
import ChipOpenClose from "./ChipOpenClose";
import IdentityAvatar from "./IdentityAvatar";
// import MutualsList, { MutualsListed } from "./MutualsList";
// import MutualCollabsList from "./MutualCollabsList";
import IdentityPageDedicatedAssistant from './IdentityPageDedicatedAssistant';
import { DedicatedAssignment } from 'stores/dedicated_assignment_store';
import IdentityBio from 'components/IdentityBio';
import { Identity } from "stores/identity_store";
import { getIcon } from "utils/misc";
import LockedFeature from 'components/LockedFeature';
import AssistantOnly from 'components/AssistantOnly';

import { DurationSeconds, TimeUI } from 'components/Date';
import FancyIcon from './FancyIcon';

// const MutualAdd = observer(({ identityKey }: { identityKey: string }) => {
//     const { addMyMutual } = useMutual();
//     const { currentIdentity } = useUserIdentity();

//     const PersonAdd = getIcon('PersonAdd');

//     return (
//         currentIdentity.key != identityKey ?
//             <Tooltip arrow title="It's like adding this person to your friends list. You can see your mutuals in the sidebar.">
//                 <Button
//                     startDecorator={<PersonAdd />}
//                     size="sm"
//                     color="success"
//                     variant="plain"
//                     onClick={() => addMyMutual(identityKey)}>Add mutual</Button>
//             </Tooltip> :
//             null
//     );
// });




// const MutualListedOptions = observer(({ identityKey }: { identityKey: string }) => {
//     const { isMutual, setMutualStatus } = useMutual();
//     const { currentIdentity, isYou } = useUserIdentity();
//     const [isUpdating, setIsUpdating] = useState(false);

//     if (!currentIdentity?.key) { return null; }
//     // do they consider me an mutual?
//     const mutual = isMutual(identityKey, currentIdentity.key);

//     function updateMutualStatus(mutual_status: string) {
//         setIsUpdating(true);
//         setMutualStatus(identityKey, currentIdentity.key, mutual_status)
//             .then(() => {
//                 Success("Updated status");
//             })
//             .catch(() => {
//                 Error("Unable to update status");
//             })
//             .finally(() => {
//                 setIsUpdating(false);
//             });

//     }

//     function allowCollaborations() {
//         updateMutualStatus('collaborators');
//     }
//     function noAllowCollaborations() {
//         updateMutualStatus('following');
//     }

//     if (isYou(identityKey)) {
//         return null;
//     }

//     if (!mutual) {
//         return (
//             <Stack direction="row" pr={1} alignItems="center">
//                 <Typography level="body-xs">
//                     This person has not added you.
//                 </Typography>
//             </Stack>
//         );
//     }
//     else {
//         if (mutual.mutual_status == 'following') {
//             return (
//                 <Stack direction="row" pr={3} spacing={1} alignItems="center">
//                     <Typography level="body-xs">
//                         This person follows you!
//                     </Typography>
//                     {isUpdating &&
//                         <Button disabled onClick={allowCollaborations}
//                             size="sm">Updating collaborations</Button>}
//                     {!isUpdating &&
//                         <Tooltip arrow
//                             title="They'll be able to invite you to their Collabs. Give it a try. You can turn it off later.">
//                             <Button variant="plain"
//                                 onClick={allowCollaborations}
//                                 size="sm">Allow collaborations</Button>
//                         </Tooltip>
//                     }
//                 </Stack>
//             );
//         }
//         else if (mutual.mutual_status == 'collaborators') {
//             return (
//                 <Stack direction="row" pr={3} spacing={1} alignItems="center">
//                     <Tooltip arrow
//                         title="They can invite you to Collabs. You can decline the invite. You are open to collaborating with this person.">
//                         <Typography level="body-xs">
//                             You are collaborators!
//                         </Typography>
//                     </Tooltip>

//                     {isUpdating &&
//                         <Button disabled onClick={allowCollaborations}
//                             size="sm">Updating collaborations</Button>}
//                     {!isUpdating &&
//                         <Tooltip arrow
//                             title="Stop allowing collaborations from this person.">
//                             <Button variant="plain"
//                                 onClick={noAllowCollaborations}
//                                 size="sm">Don't allow collaborations</Button>
//                         </Tooltip>
//                     }
//                 </Stack>
//             );

//         }
//     }
// });

// const MutualRemove = observer(({ identityKey }: { identityKey: string }) => {
//     const { removeMyMutual } = useMutual();
//     const PersonRemove = getIcon('PersonRemove');
//     return (
//         <Button
//             startDecorator={<PersonRemove />}
//             size="sm"
//             color="danger"
//             variant="plain" onClick={() => removeMyMutual(identityKey)}>Remove mutual</Button>
//     );
// });


function RoleSelector({ rolesNames, onChange, value }:
    { rolesNames: string[], onChange: (event: React.SyntheticEvent | null, newValue: string | null) => void, value: string }) {

        const roles = ['assistant', 'client'];

    return (
        <LockedFeature
            copy="Edit Role">
            <Stack >
                <Typography level="body-xs">Update the role</Typography>
                <Select
                    sx={{ width: '100%', textTransform: 'capitalize' }}
                    value={value}
                    onChange={(e, nv) => { onChange(e, nv); }}
                >
                    {rolesNames.filter(roleName => roles.includes(roleName)).map((roleName) => (
                        <Option
                            sx={{ textTransform: 'capitalize' }}
                            key={roleName}
                            value={roleName}>{roleName}</Option>
                    ))}
                </Select>

            </Stack>

        </LockedFeature>
    );
}


const SupportOnCallSwitch = observer(({ identityKey, onChange }: { identityKey: string, onChange: () => void }) => {

    const { getIdentity } = useIdentity();
    const identity = getIdentity(identityKey);

    if (!identity) { return null; }

    function setOnCall() {
        if (identity) {
            onChange();
        }
        else {
            Error("Unable to set on call support");
        }
    }

    if (identity.flags.includes('on-call-support')) {
        return (
            <Stack>
                <Typography level="body-md">This person is on call support.</Typography>
                <Typography level="body-xs">Unset this by setting it to someone else.</Typography>
            </Stack>
        );
    }
    return (
        <LockedFeature
            copy="On Call Support Status">
        <Stack direction='row' spacing={1}>
            <Typography level="body-xs">
                { identity.flags.includes('on-call-support') ? 'This preson is the ' : 'Make this person the' } On Call Support
            </Typography>
            <Switch
                    checked={identity.flags.includes('on-call-support')}
                    onChange={() => setOnCall()} />
        </Stack>
        </LockedFeature>
    );
});


const DedicatedAssistantAssigner = observer(({ identity, onChange }: { identity: Identity, onChange: (identityKey: string | null, ranking: number) => void }) => {
    const { currentIdentity } = useUserIdentity();
    const { fetchListByDedicated, identities } = useIdentity();
    const { hasRole } = useRoles();
    const workKey = useWorkKey();
    const [showForm, setShowForm] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedIdentityKey, setSelectedIdentityKey] = useState<string | null>(null);
    const { getDedicatedAssignmentsByIdentity,
        supportRemoveDedicatedAssistant,
        fetchDedicatedAssignmentsByIdentity } = useDedicatedAssignment();
    const [currentRanking, setCurrentRanking] = useState(1);

    // console.log("Identities: ", identities);
    var dedicatedTeamMembers = identities.slice().filter((i: Identity) => i.dedicated);
    if (currentIdentity?.dedicated) {
        dedicatedTeamMembers = [currentIdentity, ...dedicatedTeamMembers];
    }
    // console.log("dedicatedTeamMembers", dedicatedTeamMembers);

    const dedicatedAssignments = getDedicatedAssignmentsByIdentity(identity.key);

    useEffect(() => {
        fetchDedicatedAssignmentsByIdentity(workKey, identity.key);
    }, [workKey, identity.key, fetchDedicatedAssignmentsByIdentity]);

    useEffect(() => {
        if(hasRole('support')) {
            fetchListByDedicated(workKey);
        }
    }, [workKey, fetchListByDedicated, hasRole]);

    const CloseIcon = getIcon('Close');
    const SortIcon = getIcon('Sort');
    const DedicatedIcon = getIcon('AssignmentInd');

    function doManagerRemove(identityKey: string, assistantIdentityKey: string) {
        supportRemoveDedicatedAssistant(identityKey, assistantIdentityKey)
            .then(() => {
                Success("Removed!")
            });
    }
    function doConfirm(
        _: React.SyntheticEvent | null,
        identityKey: string | null,
    ) {
        if (!identityKey) { return; }
        setSelectedIdentityKey(identityKey);
        setShowConfirm(true);
    }

    return (
        <Stack spacing={1} padding={1}>
            <Typography level="title-sm">Dedicated Assistants</Typography>

            { dedicatedAssignments.length > 0 &&

            <List>
                {dedicatedAssignments.map((assignment: DedicatedAssignment) =>
                    <ListItem>
                        <ListItemButton>
                            <ListItemDecorator>{assignment.ranking}</ListItemDecorator>
                            <IdentityAvatar
                                size="inline"
                                interactive={true}
                                identityKey={assignment.assistant_identity} />
                        </ListItemButton>
                        <IconButton size="sm"
                            variant="plain"
                            color="warning"
                            onClick={() => doManagerRemove(assignment.identity, assignment.assistant_identity)}>
                            <CloseIcon />
                        </IconButton>
                    </ListItem>
                )}
            </List>
            }



            {!showForm &&
                <Stack>
                    <Typography level="body-xs">Build this person's dedicated team.</Typography>
                    <Button
                        variant="plain"
                        size="sm"
                        onClick={() => setShowForm(true)}>Assign Dedicated</Button>
                </Stack>
            }

            {showForm &&
                <Stack spacing={1}>
                    <Typography level="body-sm">If you don't see the (dedicated) person that you want to assign. Add them as a mutual and come back here.</Typography>
                    <FormControl>
                        <FormLabel><DedicatedIcon /> Assistant</FormLabel>
                        <FormHelperText>Select one of your (dedicated) mutuals</FormHelperText>

                        <Select onChange={doConfirm}>
                            <Option key="none" value={null}>Select a mutual</Option>
                            {dedicatedTeamMembers.map((m) =>
                                <Option
                                    key={m?.key}
                                    value={m?.key}
                                >
                                    <IdentityAvatar size="inline" interactive={false} identityKey={m?.key} />
                                </Option>


                            )}
                        </Select>
                    </FormControl>


                    <FormControl>
                        <FormLabel><SortIcon /> Ranking</FormLabel>
                        <FormHelperText>Primary, Secondary, etc.</FormHelperText>
                        <Select
                            value={currentRanking}
                            onChange={(_w, nv) => nv !== null && setCurrentRanking(nv)}
                            placeholder="Ranking"  >
                            <Option value={1}>Primary</Option>
                            <Option value={2}>Secondary</Option>
                            <Option value={3}>3</Option>
                            <Option value={4}>4</Option>
                            <Option value={5}>5</Option>
                        </Select>
                    </FormControl>

                    {showConfirm &&
                        <Button
                            variant="solid"
                            size="sm"
                            onClick={() => {
                                onChange(selectedIdentityKey, currentRanking);
                                setShowConfirm(false);
                                setShowForm(false);
                            }}>Confirm</Button>
                    }

                    <Button
                        variant="plain"
                        size="sm"
                        onClick={() => { setShowForm(false); setShowConfirm(false) }}>Cancel</Button>
                </Stack>
            }
        </Stack>
    );
});


const DedicatedSwitch = observer(({ identityKey, onChange }: { identityKey: string, onChange: (dedicated: boolean) => void }) => {

    const { getIdentity } = useIdentity();
    const identity = getIdentity(identityKey);

    if (!identity) { return null; }

    function setDedicated() {
        if (identity) {
            onChange(!identity.dedicated);
        }
    }

    return (
        <LockedFeature
            copy="Dedicated Assistant Status">
        <Stack direction='row' spacing={1}>
            <Typography level="body-xs">
                { identity.dedicated ? 'This preson is a ' : 'Make this person a' } Dedicated Assistant
            </Typography>
            <Switch
                    checked={identity.dedicated}
                    onChange={() => setDedicated()} />
        </Stack>
        </LockedFeature>
    );
});




const VerifiedSwitch = observer(({ identityKey, onChange }: { identityKey: string, onChange: (verified: string) => void }) => {

    const { getIdentity } = useIdentity();
    const identity = getIdentity(identityKey);

    function updateVerified(e: React.ChangeEvent<HTMLInputElement>) {
        const v = e.target.checked ? 'yes' : 'requested';
        onChange(v);
    }

    if (!identity || (identity && identity.verified == 'no')) {
        return <Typography level="body-xs">Not verified</Typography>
    }

    if(identity.role != 'assistant') {
        return null;
    }

    return (
        <>
            <LockedFeature
                copy="Verify Assistant">
                <Stack spacing={1}>
            <Typography
                color="danger"
                level="body-xs">
                We don't normally verify assistants.
            </Typography>

                    <Typography level="body-xs">
                        {identity.verified == 'yes' ?
                            'This is a verified identity' :
                            'Make this a verified identity'}
                    </Typography>
                    <Stack justifyContent="space-between" direction="row" spacing={1}>

                        <IdentityAvatar size="chip" interactive={false} identityKey={identityKey} />
                        <Switch
                            checked={identity?.verified == 'yes'}
                            onChange={updateVerified} />
                    </Stack>

                </Stack>
            </LockedFeature>
        </>
    );
});




const  ManagerOptions = observer(({ identityKey }: { identityKey: string }) => {
    const { getIdentity } = useIdentity();
    const identity = getIdentity(identityKey);
    const navigate = useNavigate();

    if (!identity)
        return null;


    return (
        <Stack m={1} spacing={1}>
            <Typography
                color="warning"
                level="title-md">
                Manager options
            </Typography>

            <Stack spacing={1}>


                <Stack>
                    {identity.role == 'assistant' &&
                        <>
                        <Button
                            variant="plain"
                            onClick={() => {
                                navigate(`/identity/${identityKey}/assignments`)
                            }}>View Claimed Collabs/Requests</Button>
                        </>
                        }

                </Stack>

                {identity.role == 'client' &&
                    <Stack>
                        <Button
                            variant="plain"
                            onClick={() => {
                                navigate(`/identity/${identityKey}/collabs`)
                            }}>View Collabs/Requests</Button>

                        <Button
                            variant="plain"
                            onClick={() =>
                                navigate(`/identity/${identityKey}/clock-report`)
                            }>Clock Report</Button>

                    </Stack>
                }

            </Stack>
        </Stack>
    );
})


export const  SupportOptions = observer(({ identityKey, hideUserPageLink }: { identityKey: string, hideUserPageLink?: boolean }) => {
    const { getIdentity, supportGetUserUuid } = useIdentity();

    const navigate = useNavigate();
    const identity = getIdentity(identityKey);

    const SupportAgentIcon = getIcon('SupportAgent');
    if (!identity)
        return null;
    const gotoUserPage = () => {
        supportGetUserUuid(identityKey).then((uuid: string | null) => {
            if (uuid) {
                navigate(`/support/user/${uuid}`);
            }
            else {
                Error("Unable to load user");
            }
        });
    };



    const { supportAssignDedicatedAssistant } = useDedicatedAssignment();

    const assignDedicatedAssistant = (dedicatedIdentityKey: string | null, ranking: number) => {
        if (!dedicatedIdentityKey) {
            Error("Not assigning dedicated assistant, no identity(?)");
            return;
        }

        supportAssignDedicatedAssistant(identityKey, dedicatedIdentityKey, ranking)
            .then(() => {
                Success("Assigned a dedicated assistant");
            }).
            catch((err) => {
                Error("Unable to assign a dedicated assistant");
                console.error(err);
            });

    }

    return (
        <Stack m={1} spacing={1}>
            <Typography
                color="success"
                startDecorator={<SupportAgentIcon />}
                level="title-md">
                Support Options
            </Typography>

            <Stack spacing={1}>

                <Stack>
                    <Typography level="body-xs">
                        Subscription Service
                    </Typography>
                    <Typography level="body-md">{identity.subscription_service}</Typography>
                </Stack>
                <Stack>
                    <Typography level="body-xs">
                        Subscription Product
                    </Typography>
                    <Typography level="body-md">{identity.subscription_product}</Typography>
                </Stack>

                {identity.next_billing_cycle_date &&
                    <Stack>
                        <Typography level="body-xs">

                            Next Billing Cycle Date

                        </Typography>
                        <Typography level="body-md"><TimeUI ts={identity.next_billing_cycle_date} /></Typography>
                    </Stack>
                }


                {['dedicated', 'dayones'].includes(identity.subscription_product) &&
                    <>
                        <Stack>
                            <Typography level="body-xs">
                                Time Included
                            </Typography>
                            <Typography level="body-md"><DurationSeconds seconds={identity.credit_included * 60} /></Typography>
                        </Stack>
                        <Stack>
                            <Typography level="body-xs">

                                                            Time Remaining {identity.current_credit}
                            </Typography>
                            <Typography level="body-md"><DurationSeconds seconds={identity.current_credit * 60} /></Typography>
                        </Stack>
                    </>
                }

            { identity.role == 'client' && !['dedicated', 'dayones'].includes(identity.subscription_product) &&
                    <Stack>
                        <Typography level="body-xs">
                            Tasks Remaining
                        </Typography>
                        <Typography level="body-md">{identity.tasks_remaining}</Typography>
                    </Stack>
            }

            { identity.role == 'client' && identity.subscription_product == 'dedicated' &&

                        <LockedFeature copy="Assign Dedicated Assistant">
                            <DedicatedAssistantAssigner
                                identity={identity}
                                onChange={assignDedicatedAssistant} />
                                </LockedFeature>
            }

                {identity.role == 'assistant' &&
                    <List>
                        <ListItem>

                            <ListItemDecorator>
                                <FancyIcon name="DayOnesClockOut" />
                            </ListItemDecorator>
                            <Link to={`/assistant/${identity.uuid}/clock-report?default=today`}>
                                Clock Report
                            </Link>

                        </ListItem>
                    </List>
            }

                    {!hideUserPageLink &&
                        <Button
                            variant="plain"
                            onClick={gotoUserPage}>User Page</Button>
                    }



                               {/*
                <Typography level="body-xs"
                    endDecorator={<Chip>{identity.minutes_remaining}</Chip>}   >
                    Minutes Remaining
                    </Typography>*/}

            </Stack>
        </Stack>
    );
})

const SudoOptions = observer(({ identityKey }: { identityKey: string }) => {

    const { sudoSetVerified, sudoSetDedicated, sudoSetOnCallSupport } = useIdentity();
    const workKey = useWorkKey();

    const { currentIdentity, updateRole } = useUserIdentity();
    const { getIdentity } = useIdentity();
    const { rolesNames } = useRoles();
    const showRolesSelector = rolesNames.length > 1;
    const identity = getIdentity(identityKey);
    const navigate = useNavigate();

    const handleChange = (
        _: React.SyntheticEvent | null,
        newValue: string | null,
    ) => {
        if (!identityKey) { return; }
        if (!currentIdentity) { return; }

        if (newValue) {
            updateRole(identityKey, newValue).then(() => {
                Success("Updated role!!!");
            });
        }
        else {
            Error("Did not update role.");
        }

    };

    const setDedicated = (dedicated: boolean) => {
        if (!identity) {
            Error("Error seting dedicated, no identity(?)");
            return;
        }
        if (dedicated != identity.dedicated) {
            identity.dedicated = dedicated;

            sudoSetDedicated(identity.key, identity.dedicated)
                .then(() => {
                    if (dedicated) {
                        Success("This assistant is now dedicated");
                    }
                    else {
                        Success("This assistant is no longer dedicated");
                    }
                })
                .catch((error) => {
                    Error("Unable to update dedicated");
                    console.error(error);
                });
        }
    };

    const setOnCallSupport = () => {
        if (!identity) {
            Error("Error seting dedicated, no identity(?)");
            return;
        }
        if(!workKey)
            return;

        sudoSetOnCallSupport(workKey, identity.key)
                .then(() => {
                        Success("This assistant is now the on call support");
                })
                .catch((error) => {
                    Error("Unable to update on call support");
                    console.error(error);
                });

    };

    const setVerified = (verified: string) => {

        if (!identity) {
            Error("Error seting dedicated, no identity(?)");
            return;
        }

        if (verified != identity.verified) {
            identity.verified = verified;
            sudoSetVerified(identity.key, (verified === 'yes')).then(() => {
                if (verified === 'yes') {
                    Success("This identity is now verified");
                }
                else {
                    Success("This identity is no longer verified");
                }
            });
        }
    };


    if (!rolesNames.includes('sudo')) {
        return null;
    }

    if (!identity) {
        return null;
    }

    return (
        <Stack>
            <Stack
                spacing={1}
                p={1}>

                { showRolesSelector ?
                    <RoleSelector
                        rolesNames={rolesNames}
                        value={identity.role}
                        onChange={handleChange} /> :
                    <Typography level="body-xs">This is a {identity.role}</Typography>
                 }

                {identity.role == 'assistant' &&
                    <>
                    <DedicatedSwitch
                        identityKey={identityKey}
                        onChange={setDedicated} />
                        <SupportOnCallSwitch
                            onChange={setOnCallSupport}
                            identityKey={identityKey} />
                    </>
                }


                {(rolesNames.includes('sudo') && identity.verified != 'no') &&
                    <VerifiedSwitch
                        identityKey={identityKey}
                        onChange={setVerified} />
                }

                {rolesNames.includes('sudo') &&
                    <Stack>
                        <Button
                            variant="plain"
                            onClick={() => {
                                navigate(`/manager/redis?search=json:${identityKey}`)
                            }}>Redis</Button>
                    </Stack>
                }

            </Stack>
        </Stack>
    );

});




const AssistantOptions = observer(({ identityKey }: { identityKey: string }) => {
    const { rolesNames } = useRoles();
    console.log("AssistantOptions: %o", rolesNames);
    return (
        <Grid container
            spacing={3}>
                        {rolesNames.includes('support') &&
                <Grid xs={12} sm={4}>
                    <ChipOpenClose
                        title="Support Options"
                        cached="id-page-support-options"
                        defaultOpen={true}>
                        <SupportOptions identityKey={identityKey} />
                    </ChipOpenClose>
                </Grid>
                        }

            {rolesNames.includes('manager') &&
                <Grid xs={12} sm={4}>
                    <ChipOpenClose
                        title="Manager Options"
                        cached="id-page-manager-options"
                        defaultOpen={true}>
                        <ManagerOptions identityKey={identityKey} />
                    </ChipOpenClose>
                </Grid>
            }

            {rolesNames.includes('sudo') &&
                <Grid xs={12} sm={4}>
                    <ChipOpenClose
                        title="Sudo Options"
                        cached="id-page-sudo-options"
                        defaultOpen={true}>
                        <SudoOptions identityKey={identityKey} />
                    </ChipOpenClose>
                </Grid>
            }

        </Grid>
    );
});

const IdentityPage = observer(() => {
    const { identityKey } = useParams<{ identityKey: string }>();
    const { getIdentity, fetchIdentity } = useIdentity();
    const { currentIdentity, isYou } = useUserIdentity();
    const { fetchMutualsListed } = useMutual();
    // const { hasRole } = useRoles();
    // const { isMutual } = useMutual();

    if (!identityKey) { return null; }

    const identity = getIdentity(identityKey);
    useEffect(() => {
        if (identityKey && !identity && currentIdentity?.uuid) {
            console.log("fetching identity");
            fetchIdentity(currentIdentity?.uuid, identityKey);
        }
    }, [identityKey, identity, currentIdentity?.uuid]);


    useEffect(() => {
        console.log("fetching mutuals", identityKey);
        fetchMutualsListed(identityKey);
    }, [fetchMutualsListed, identityKey]);


    if (!identityKey) {
        return <div>Loading</div>
    }

    if (!identity) {
        return <div>Loading or not found</div>
    }
    //    console.log("verified: %o", identity.verified);



    return (
        <Stack m={1} spacing={3}>
            <Stack>
                { isYou(identityKey) &&
                    <Stack
                        justifyContent="center"
                        width="100%"
                        direction="row"
                        spacing={1}>
                        <Typography level="body-xs">
                            This is what we share about you to your
                            { currentIdentity.role == 'assistant' ?
                                " clients" : " assistants"
                            }
                        </Typography>
                    </Stack>
                 }
                <Stack
                    pt={1}
                    pb={2}
                    direction="row"
                    justifyContent="center">

                    <Stack
                        direction="row"
                        padding={1}
                        spacing={1}
                    >
                        <Box flexGrow={1} />


                        {/* currentIdentity.key !== identityKey &&
                            <Stack direction="row">
                                <MutualListedOptions identityKey={identityKey} />

                                {isMutual(currentIdentity.key, identityKey) ?
                                    <MutualRemove identityKey={identityKey} /> :
                                    <MutualAdd identityKey={identityKey} />
                                }
                            </Stack>
                            */}
                    </Stack>
                </Stack>
                <Stack >
                <IdentityBio identityKey={identityKey} />
                </Stack>
            </Stack>


            {/* Dedicated Assistant Stuff */}
            <IdentityPageDedicatedAssistant identityKey={identityKey} />

            {/*
            <MutualCollabsList identityKey={identityKey} />
              */}
            {/*
            {  hasRole('manager') &&
                <Card>
                    <Typography level="body-xs" color="danger">Manager Only</Typography>
                <Grid container padding={3} >
                    <Grid xs={12} sm={4} >
                        {isYou(identityKey) &&
                            <Typography level="body-xs">This is you!</Typography>}
                        {!isYou(identityKey) &&
                            <MutualCollabsList identityKey={identityKey} />}

                    </Grid>
                    <Grid xs={12} sm={4}>
                        <MutualsList identityKey={identityKey} />
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <MutualsListed identityKey={identityKey} />
                    </Grid>
                </Grid>
                </Card>
            }
              */}

                { currentIdentity.role == 'assistant' &&
                    <AssistantOnly>
                        <AssistantOptions identityKey={identityKey} />
                    </AssistantOnly>
                }
        </Stack>
    );

});
export default IdentityPage;
